const UserStatuses = {
  ACTIVE: "Active",
  DEACTIVATED: "Deactivated",
  REGISTERED: "Registered"
};

UserStatuses.ALL = Object.values(UserStatuses);

module.exports = UserStatuses;
